
export const getAppointmentStatus = (status) => {
    let badgeClass = 'badge-light-warning';
    let label = status;

    switch (status) {
        case 'confirmed':
            badgeClass = 'badge-light-primary';
            label = 'Confirmed';
            break;
        case 'checkup_process':
            badgeClass = 'badge-light-info';
            label = 'Under Pre-test';
            break;
        case 'pre_test_done':
            badgeClass = 'badge-light-primary';
            label = 'Pending (Pre-test Done)';
            break;
        case 'checkup_completed':
            badgeClass = 'badge-light-success';
            label = 'Checkup Completed';
            break;
        case 'completed':
            badgeClass = 'badge-light-success';
            label = 'Completed';
            break;
        case 'cancelled':
            badgeClass = 'badge-light-danger';
            label = 'Cancelled';
            break;
        case 'queue':
            badgeClass = 'badge-light-warning';
            label = 'Queue';
            break;
        case 'pending':
        default:
            badgeClass = 'badge-light-warning';
            // Capitalize first letter for other statuses
            label = status ? status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, ' ') : 'Pending';
            break;
    }

    return { badgeClass, label };
};

export const getOrderStatus = (status) => {
    let badgeClass = 'badge-light-secondary';
    let label = status;

    switch (status) {
        case 'pending':
            badgeClass = 'badge-light-warning';
            label = 'Pending';
            break;
        case 'completed':
            badgeClass = 'badge-light-success';
            label = 'Complete (collected)';
            break;
        case 'cancelled':
            badgeClass = 'badge-light-danger';
            label = 'Cancelled';
            break;
        case 'ready_not_collected':
            badgeClass = 'badge-light-info';
            label = 'Ready NOT collected';
            break;
        default:
            badgeClass = 'badge-light-secondary';
            label = status ? status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, ' ') : 'Unknown';
            break;
    }

    return { badgeClass, label };
};

export const getGenericStatus = (status) => {
    let badgeClass = 'badge-light-secondary';
    let label = status;

    if (status === 'active' || status === true || status === 1) {
        badgeClass = 'badge-light-success';
        label = 'Active';
    } else if (status === 'inactive' || status === false || status === 0) {
        badgeClass = 'badge-light-danger';
        label = 'Inactive';
    }

    return { badgeClass, label };
};
